import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { useHelpers, useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useRoute } from 'vue-router'

export const useSendForm = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()
  const route = useRoute()
  const queryClient = useQueryClient()
  const { getDifferentObject } = useHelpers()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      return http.put(`/cabinets/${route.params.object_id}/admin/communication`, data)
    },
  })

  const sendForm = async (data: any, origin: any, valid: boolean) => {
    if (!valid) return

    try {
      /** Проверка на наличие измененных данных */
      const diffData = getDifferentObject(origin, data)
      if (!Object.keys(diffData).length) return

      await mutation.mutateAsync(diffData)

      addSuccess(trs('itf.saved'))

      await queryClient.fetchQuery({ queryKey: ['load_cabinet', route.params.object_id] })
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    sendForm,
  }
}
